import pro6ppClient from '../../../pro6pp-client';
import { newObject } from '../../../../signature-utils';

export default function getDefaultState() {
  return {
    cancellationId: undefined,
    cancellation: {},
    showErrors: false,
    showPaymentTypeErrors: false,
    paymentMethods: [],
    optionalProduct: null,
    payments: {},
    cancellationOptions: [],
    subCancellations: {},
    activeCancellation: null,
    formFields: {},
    additionalFormFields: {},
    additionalFormFieldValues: {},
    ibanFormField: null,
    reasonToCancelFormField: null,
    formFieldValidityStates: {},
    drawnSignatureRequired: null,
    reasonToCancelRequired: null,
    setupComplete: false,
    paymentType: {
      paymentType: 1,
      agreeTerms: false,
      iban: null,
    },
    security: null,
    paymentTypeValidity: {},
    signatureData: undefined,
    inputRefs: {},
    client: pro6ppClient,
    addressIsValid: true,
    isLoading: false,
    cache: {},
    country: {
      netherlands: false,
      belgium: false,
    },
    adivareSignaturePad: newObject(),
    signatureMode: undefined,
    generic: false,
    cancellationDate: null,
    totalPrice: null,
  };
}
